import React from 'react';
import PropTypes from 'prop-types';

import { ModalLauncher } from '@metarouter-private/mr-mui';

import RevisionEnabledSwitch from './RevisionEnabledSwitch';
import DisableRevisionModal from './DisableRevisionModal';

export default function RevisionEnabledCell({ playbook }) {
  return (
    <ModalLauncher
      Launcher={RevisionEnabledSwitch}
      launcherProps={{ playbook }}
      Modal={DisableRevisionModal}
      modalProps={{ playbook }}
    />
  );
}

RevisionEnabledCell.propTypes = {
  playbook: PropTypes.object.isRequired,
};
